import React from "react";
import { useNavigate } from "react-router-dom";
import "./Payment-failed.css";

const PaymentFailed = () => {

    const navigate = useNavigate();

    return (

        <div className="paymentFailed-overlay">

            <div className="paymentFailed-popup">

                <button
                    className="close-btn"
                    onClick={() => navigate("/client/payment")}
                >
                    ✕
                </button>

                <div className="failed-icon">
                    ✕
                </div>

                <h2 className="failed-title">
                    Payment Failed
                </h2>

                <p className="failed-message">
                    We couldn't process your payment.
                    Please try again or use another payment method.
                </p>

                <div className="failed-reason-card">

                    <span className="failed-label">
                        Status
                    </span>

                    <span className="failed-value">
                        Transaction Unsuccessful
                    </span>

                </div>

                <div className="failed-badge">
                    ⚠ Payment Not Completed
                </div>

                <button
                    className="retry-btn"
                    onClick={() => navigate("/client/payment")}
                >
                    Try Again
                </button>

            </div>

        </div>
    );
};

export default PaymentFailed;